import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {IconService} from './services/icon.service';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  constructor(private readonly iconService: IconService, translateService: TranslateService) {
    this.iconService.setFavicon(environment.cdnPath + '/logos/finbricks/whitebricks/whitebricks-favicon.ico');
    translateService.addLangs(['sk', 'en']);
    const browserLang = translateService.getBrowserLang();
    console.info('AppComponent.constructor browserLang:', browserLang);
    translateService.use(browserLang?.match(/sk|en/) ? browserLang : 'sk');
  }
}
